import { Stack, Typography } from '@mui/material';
import {
  CompaniesCarousel,
  MacBookWindow,
  Section,
} from '@rumblefish/ui/Rumblefish23Theme';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Bringing you custom <br /> DeFi product development <br /> from A to
            Z
          </>
        }
        description={
          <>
            Decentralized finance product development tailored to <b>your</b>{' '}
            needs
          </>
        }
        buttonText="Book a free consultation"
        buttonLink="/contact"
        gradient="orange"
      />

      <Section width="normal">
        <Stack
          sx={(theme) => ({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(7),
            marginTop: theme.spacing(6),
            textAlign: 'center',
            marginBottom: theme.spacing(16),
            [theme.breakpoints.down('md')]: {
              marginBottom: theme.spacing(15),
            },
            [theme.breakpoints.down('sm')]: {
              marginBottom: theme.spacing(9),
            },
          })}>
          <Typography
            sx={{
              color: (theme) => theme.palette.invertedContent?.PRIMARY,
            }}
            variant="strong_400">
            Rumble Fish is your trusted end-to-end DeFi development company.
            <br />
            We know the decentralized finance market inside out so feel free to
            use our expertise and tech savviness to bring your DeFi product idea
            to life.
            <br />
            We’ve worked with various decentralized finance entities to help
            them design, develop, and maintain their exchange platforms, lending
            protocols, or staking solutions.
          </Typography>
          <CompaniesCarousel />
        </Stack>
      </Section>
    </>
  );
};
